export const FETCH_SITES_START = '[Sites] FETCH_SITES_START';
export const FETCH_SITES_FAIL = '[Sites] FETCH_SITES_FAIL';
export const SET_SITES = '[Sites] SET_SITES';
export const SET_SITES_FILTERS_STATUS = '[Sites] SET_SITES_FILTERS_STATUS';
export const SET_SITES_FILTERS_CUSTOMER = '[Sites] SET_SITES_FILTERS_CUSTOMER';
export const SET_SITES_FILTERS_AREA = '[Sites] SET_SITES_FILTERS_AREA';
export const SET_SITES_FILTERS_LOCATION = '[Sites] SET_SITES_FILTERS_LOCATION';
export const RESET_SITE_EVENTS = '[Sites] RESET_SITES_EVENTS';
export const RESET_SITES_FILTERS = '[Sites] RESET_SITES_FILTERS';

export const SET_SITES_FILTERS_TEXT = '[Sites] SET_SITES_FILTERS_TEXT';
export const SET_SITES_FILTERS_ASSIGNED_USER = '[Sites] SET_SITES_FILTERS_ASSIGNED_USER';
export const SET_SITES_FILTERS_EMULATED_SITES = '[Sites] SET_SITES_FILTERS_EMULATED_SITES';

export const FETCH_SITE_DETAILS = '[Sites] FETCH_SITE_DETAILS';
export const FETCH_SITE_DETAILS_FAIL = '[Sites] FETCH_SITE_DETAILS_FAIL';
export const SET_SITE_DETAILS = '[Sites] SET_SITE_DETAILS';

export const FETCH_SITE_TELEMETRY = '[Sites] FETCH_SITE_TELEMETRY';
export const SET_SITE_TELEMETRY = '[Sites] SET_SITE_TELEMETRY';
export const FETCH_SITE_TELEMETRY_FAIL = '[Sites] FETCH_SITE_TELEMETRY_FAIL';
export const FETCH_SITE_OVERVIEW_DETAILS = '[Sites] FETCH_SITE_OVERVIEW_DETAILS';
export const SET_SITE_OVERVIEW_DETAILS = '[Sites] SET_SITE_OVERVIEW_DETAILS';
export const FETCH_SITE_OVERVIEW_DETAILS_FAIL = '[Sites] FETCH_SITE_OVERVIEW_DETAILS_FAIL';
export const SAVE_SITE_OVERVIEW_DETAILS = '[Sites] SAVE_SITE_OVERVIEW_DETAILS';
export const SAVE_SITE_OVERVIEW_DETAILS_SUCCESS = '[Sites] SAVE_SITE_OVERVIEW_DETAILS_SUCCESS';
export const SAVE_SITE_OVERVIEW_DETAILS_FAIL = '[Sites] SAVE_SITE_OVERVIEW_DETAILS_FAIL';

export const FETCH_SITE_EVENTS = '[Sites] FETCH_SITE_EVENTS';
export const SET_SITE_EVENTS = '[Sites] SET_SITE_EVENTS';
export const SET_SITE_EVENT_FILTERS = '[Sites] SET_SITE_EVENT_FILTERS';
export const FETCH_SITE_EVENTS_FAIL = '[Sites] FETCH_SITE_EVENTS_FAIL';

export const FETCH_SITE_EVENT_COUNTS = '[Sites] FETCH_SITE_EVENT_COUNTS';
export const SET_SITE_EVENT_COUNTS = '[Sites] SET_SITE_EVENT_COUNTS';
export const FETCH_SITE_EVENT_COUNTS_FAIL = '[Sites] FETCH_SITE_EVENT_COUNTS_FAIL';

export const FETCH_SITE_EVENT_DAILY_COUNTS = '[Sites] FETCH_SITE_EVENT_DAILY_COUNTS';
export const SET_SITE_EVENT_DAILY_COUNTS = '[Sites] SET_SITE_EVENT_DAILY_COUNTS';
export const FETCH_SITE_EVENT_DAILY_COUNTS_FAIL = '[Sites] FETCH_SITE_EVENT_DAILY_COUNTS_FAIL';

export const FETCH_SITES_ICIAN_USERS_START = '[Sites] FETCH_SITES_ICIAN_USERS_START';
export const SET_SITES_ICIAN_USERS = '[Sites] SET_SITES_ICIAN_USERS';
export const FETCH_SITES_ICIAN_USERS_FAIL = '[Sites] FETCH_SITES_ICIAN_USERS_FAIL';

export const FETCH_SITE_BUS_BAND = '[Sites] FETCH_SITE_BUS_BAND';
export const SET_SITE_BUS_BAND = '[Sites] SET_SITE_BUS_BAND';
export const FETCH_SITE_BUS_BAND_FAIL = '[Sites] FETCH_SITE_BUS_BAND_FAIL';
export const PATCH_SITE_BUS_BAND_POINTS = '[Sites] PATCH_SITE_BUS_BAND_POINTS';
export const PATCH_SITE_BUS_BAND_POINTS_FAIL = '[Sites] PATCH_SITE_BUS_BAND_POINTS_FAIL';
export const SET_BUS_BAND_STATUS_START = '[Sites] SET_BUS_BAND_STATUS_START';
export const SET_BUS_BAND_STATUS = '[Sites] SET_BUS_BAND_STATUS';
export const SET_BUS_BAND_STATUS_FAIL = '[Sites] SET_BUS_BAND_STATUS_FAIL';
export const SET_BUS_BAND_STATUS_CLEAN = '[Sites] SET_BUS_BAND_STATUS_CLEAN';

export const FETCH_SITE_AUDIT_LOG = '[Sites] FETCH_SITE_AUDIT_LOG';
export const SET_SITE_AUDIT_LOG = '[Sites] SET_SITE_AUDIT_LOG';
export const FETCH_SITE_AUDIT_LOG_FAIL = '[Sites] FETCH_SITE_AUDIT_LOG_FAIL';
export const SET_SITE_AUDIT_LOG_FILTERS = '[Sites] SET_SITE_AUDIT_LOG_FILTERS';
export const SET_SITE_AUDIT_LOG_MORE_RESULTS = '[Sites] SET_SITE_AUDIT_LOG_MORE_RESULTS';

export const FETCH_CA_CERTIFICATE = '[Sites] FETCH_CA_CERTIFICATE';
export const SET_CA_CERTIFICATE = '[Sites] SET_CA_CERTIFICATE';
export const FETCH_CA_CERTIFICATE_FAIL = '[Sites] FETCH_CA_CERTIFICATE_FAIL';

export const CLEAN_SITE_AUDIT_LOG_FILTERS = '[Sites] CLEAN_SITE_AUDIT_LOG_FILTERS';

export const FETCH_TARIFF_STRUCTURE_START = '[Sites] FETCH_TARIFF_STRUCTURE_START';
export const FETCH_OKTA_USERS_START = '[Sites] FETCH_OKTA_USERS_START';
export const SET_OKTA_USERS = '[Sites] SET_OKTA_USERS';
export const FETCH_OKTA_USERS_FAIL = '[Sites] FETCH_OKTA_USERS_FAIL';

export const FETCH_USERS_PERMISSIONS_START = '[Sites] FETCH_USERS_PERMISSIONS_START';
export const SET_USERS_PERMISSIONS = '[Sites] FETCH_USERS_PERMISSIONS';
export const FETCH_USERS_PERMISSIONS_FAIL = '[Sites] FETCH_USERS_PERMISSIONS_FAIL';
export const DELETE_USER_PERMISSIONS_START = '[Sites] DELETE_USER_PERMISSIONS_START';
export const DELETE_USER_PERMISSIONS = '[Sites] DELETE_USER_PERMISSIONS';
export const DELETE_USER_PERMISSIONS_FAIL = '[Sites] DELETE_USER_PERMISSIONS_FAIL';

export const SET_TIME_ZONE_START = '[Sites] SET_TIME_ZONE_START';
export const UPDATE_TIME_ZONE = '[Sites] SET_TIME_ZONE';
export const SET_TIME_ZONE_FAIL = '[Sites] SET_TIME_ZONE_FAIL';
export const FETCH_TIME_ZONES_START = '[Sites] FETCH_TIME_ZONES_START';
export const SET_TIME_ZONES = '[Sites] FETCH_TIME_ZONES_START';
export const FETCH_TIME_ZONES_FAIL = '[Sites] FETCH_TIME_ZONES_START';
export const FETCH_SITE_TYPE_START = '[Sites] FETCH_SITE_TYPE_START';
export const RESET_SITE_TYPE = '[Sites] RESET_SITE_TYPE';
export const SET_SITE_TYPE = '[Sites] SET_SITE_TYPE';
export const SET_SITE_TYPE_FAIL = '[Sites] SET_SITE_TYPE_FAIL';
export const FETCH_SITE_TYPES_START = '[Sites] FETCH_SITE_TYPES_START';
export const SET_SITE_TYPES = '[Sites] SET_SITE_TYPES';
export const FETCH_SITE_TYPES_FAIL = '[Sites] FETCH_SITE_TYPES_FAIL';
export const SET_SITE_USERNAME_PASSWORD = '[Sites] SET_SITE_USERNAME_PASSWORD';

export const SET_TARIFF_STRUCTURE = '[Sites] SET_TARIFF_STRUCTURE';
export const FETCH_TARIFF_STRUCTURE_FAIL = '[Sites] FETCH_TARIFF_STRUCTURE_FAIL';
export const SET_TARIFF_STRUCTURE_START = '[Sites] SET_TARIFF_STRUCTURE_START';
export const SET_TARIFF_STRUCTURE_FAIL = '[Sites] SET_TARIFF_STRUCTURE_FAIL';

export const FETCH_COMPANIES_SITES_START = '[Sites] FETCH_COMPANIES_SITES_START';
export const SET_COMPANIES_SITES = '[Sites] SET_COMPANIES_SITES';
export const FETCH_COMPANIES_SITES_FAIL = '[Sites] FETCH_COMPANIES_SITES_FAIL';
export const SET_CRADLE_POINT_ROUTER_ID_START = '[Sites] SET_CRADLE_POINT_ROUTER_ID_START';
export const SET_CRADLE_POINT_ROUTER_ID = '[Sites] SET_CRADLE_POINT_ROUTER_ID';
export const SET_CRADLE_POINT_ROUTER_ID_FAIL = '[Sites] SET_CRADLE_POINT_ROUTER_ID_FAIL';

export const SET_EDGE_DATA_TIMEOUT_START = '[Sites] SET_EDGE_DATA_TIMEOUT_START';
export const SET_EDGE_DATA_TIMEOUT = '[Sites] SET_EDGE_DATA_TIMEOUT';
export const SET_EDGE_DATA_TIMEOUT_FAIL = '[Sites] SET_EDGE_DATA_TIMEOUT_FAIL';

export const UPDATE_BUS_BAND_TABS_DISABLED = '[Sites] UPDATE_BUS_BAND_TABS_DISABLED';
export const REDIRECTING_WITH_FILTERS = '[Sites] REDIRECTING_WITH_FILTERS';

export const SET_BILLING_INFO = '[Sites] SET_BILLING_INFO';
export const FETCH_BILLING_INFO_FAIL = '[Sites] FETCH_BILLING_INFO_FAIL';
export const FETCH_BILLING_INFO = '[Sites] FETCH_BILLING_INFO';

export const SET_SITE_CONFIGURATION_START = '[Sites] SET_SITE_CONFIGURATION_START';
export const UPDATE_SITE_CONFIGURATION = '[Sites] UPDATE_SITE_CONFIGURATION';
export const SET_SITE_CONFIGURATION_FAIL = '[Sites] SET_SITE_CONFIGURATION_FAIL';
export const FETCH_SITE_CONFIGURATION_START = '[Sites] FETCH_SITE_CONFIGURATION_START';
export const SET_SITE_CONFIGURATION = '[Sites] SET_SITE_CONFIGURATION';
export const FETCH_SITE_CONFIGURATION_FAIL = '[Sites] FETCH_SITE_CONFIGURATION_FAIL';

export const SET_WORK_ORDERS = '[Sites] SET_WORK_ORDERS';
export const FETCH_WORK_ORDERS_FAIL = '[Sites] FETCH_WORK_ORDERS_FAIL';

export const UPDATE_WORK_ORDERS_START = '[Sites] UPDATE_WORK_ORDERS_START';
export const UPDATE_WORK_ORDERS_FAIL = '[Sites] UPDATE_WORK_ORDERS_FAIL';
